import React from 'react';

export interface ResetableStateInjectedProps {
  resetState: () => void;
}

/**
 * HOC to wrap modals so their state can be reset after they are hidden but not unmounted
 */
export function resetableState<P extends ResetableStateInjectedProps>(
  Component: React.ComponentType<P>
): React.ComponentType<Omit<P, keyof ResetableStateInjectedProps>> {
  return function ResetableStateComponent(props: P) {
    const [currentKey, setCurrentKey] = React.useState(0);

    return (
      <Component
        key={currentKey}
        {...props}
        resetState={() => setCurrentKey(currentKey + 1)}
      />
    );
  };
}
